// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

function LankuButton(props) {
    const { variation, link, size, children, linkElementType } = props;
    const [finalURL, setFinalURL] = useState('');

    useEffect(() => {
        const url = flattenToAppURL(link);
        let newFinalURL = url;
        if (linkElementType === 'Image' && !url.endsWith('/@@images/image')) {
            newFinalURL = `${url}/@@images/image`;
        } else if (
            linkElementType === 'File' &&
            !url.endsWith('/@@download/file')
        ) {
            newFinalURL = `${url}/@@download/file`;
        }
        setFinalURL(newFinalURL);
    }, [link, linkElementType]);

    return (
        finalURL && (
            <UniversalLink
                href={finalURL}
                download={linkElementType === 'Image'}
                className={`ui ${variation} button ${size}`}
            >
                {children}
            </UniversalLink>
        )
    );
}

LankuButton.propTypes = {
    variation: PropTypes.string,
    link: PropTypes.string,
    size: PropTypes.string,
    children: PropTypes.node,
    linkElementType: PropTypes.string,
};
export default LankuButton;
